export enum SubscriptionEditSubView {
  INTERVAL = 'interval',
  NEXT_SHIPPING_DATE = 'next-shipping-date',
  SHIPPING_ADDRESS = 'shipping-address',
  BILLING_ADDRESS = 'billing-address',
  PAYMENT_METHO = 'payment-method',
  SUBSCRIPTION_STATUS = 'subscription-status',
}

/**
 * Error message for subscription update
 * */
export const SubscriptionErrorMessageKey = {
  /** SubscriptionMovError when subscription is below MOV */
  SubscriptionMovError: 'SubThresholdNotMet',
} as const;

export type SubscriptionErrorMessageKey =
  (typeof SubscriptionErrorMessageKey)[keyof typeof SubscriptionErrorMessageKey];
